import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";

const sideBarConstantsDesigner: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.designer.home.path,
        title: routeConstant.designer.home.title,
        Icon: Icons.MenuIcon,
        IconActive: Icons.MenuIconActive,
      },
      {
        path: routeConstant.designer.myProjects.path,
        title: routeConstant.designer.myProjects.title,
        Icon: Icons.ProjectsIcon,
        IconActive: Icons.ProjectsIconActive,
      },
      {
        path: routeConstant.designer.allProjects.path,
        title: routeConstant.designer.allProjects.title,
        Icon: Icons.ProjectsIcon,
        IconActive: Icons.ProjectsIconActive,
      },
      {
        path: routeConstant.designer.archivedProjects.path,
        title: routeConstant.designer.archivedProjects.title,
        Icon: Icons.ArchiveInactiveIcon,
        IconActive: Icons.ArchiveIconActive,
      },
      {
        path: routeConstant.designer.notifications.path,
        title: routeConstant.designer.notifications.title,
        Icon: Icons.Bell,
        IconActive: Icons.Bell,
      },
    ],
  },
  {
    title: "Setting",
    paths: [
      {
        path: routeConstant.designer.accountSetting.path,
        title: routeConstant.designer.accountSetting.title,
        Icon: Icons.Settings,
        IconActive: Icons.Settings,
      },
    ],
  },
];

export const mobileNavItems: MobileNavItem[] = [
  {
    path: routeConstant.designer.home.path,
    label: "Dashboard",
    icon: Icons.MenuIcon,
  },
  {
    path: routeConstant.designer.myProjects.path,
    label: "My Projects",
    icon: Icons.ProjectIcon2,
  },
  {
    path: routeConstant.designer.allProjects.path,
    label: "Projects",
    icon: Icons.ProjectIcon2,
  },
  {
    path: routeConstant.designer.notifications.path,
    label: "History",
    icon: Icons.Bell,
  },
  {
    path: routeConstant.designer.accountSetting.path,
    label: "Settings",
    icon: Icons.SettingsIcon2,
  },
];

const clientSideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.client.projects.path,
        title: routeConstant.client.projects.title,
        Icon: Icons.ProjectsIcon,
        IconActive: Icons.ProjectsIconActive,
      },
      {
        path: routeConstant.client.archivedProjects.path,
        title: routeConstant.client.archivedProjects.title,
        Icon: Icons.ArchiveInactiveIcon,
        IconActive: Icons.ArchiveIconActive,
      },
      {
        path: routeConstant.client.documents.path,
        title: routeConstant.client.documents.title,
        Icon: Icons.DocumentIcon,
        IconActive: Icons.DocumentIcon,
      },
      {
        path: routeConstant.client.notifications.path,
        title: routeConstant.client.notifications.title,
        Icon: Icons.Bell,
        IconActive: Icons.Bell,
      },
    ],
  },
  {
    title: "Setting",
    paths: [
      {
        path: routeConstant.client.accountSetting.path,
        title: routeConstant.client.accountSetting.title,
        Icon: Icons.Settings,
        IconActive: Icons.Settings,
      },
    ],
  },
];

const builderSideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.builder.projects.path,
        title: routeConstant.builder.projects.title,
        Icon: Icons.ProjectsIcon,
        IconActive: Icons.ProjectsIconActive,
      },
      {
        path: routeConstant.builder.archivedProjects.path,
        title: routeConstant.builder.archivedProjects.title,
        Icon: Icons.ArchiveInactiveIcon,
        IconActive: Icons.ArchiveIconActive,
      },
      {
        path: routeConstant.builder.notifications.path,
        title: routeConstant.builder.notifications.title,
        Icon: Icons.Bell,
        IconActive: Icons.Bell,
      },
    ],
  },
  {
    title: "Setting",
    paths: [
      {
        path: routeConstant.builder.accountSetting.path,
        title: routeConstant.builder.accountSetting.title,
        Icon: Icons.Settings,
        IconActive: Icons.Settings,
      },
    ],
  },
];

const collaboratorSideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.collaborator.projects.path,
        title: routeConstant.collaborator.projects.title,
        Icon: Icons.ProjectsIcon,
        IconActive: Icons.ProjectsIconActive,
      },
      {
        path: routeConstant.collaborator.archivedProjects.path,
        title: routeConstant.collaborator.archivedProjects.title,
        Icon: Icons.ArchiveInactiveIcon,
        IconActive: Icons.ArchiveIconActive,
      },
      {
        path: routeConstant.collaborator.documents.path,
        title: routeConstant.collaborator.documents.title,
        Icon: Icons.DocumentIcon,
        IconActive: Icons.DocumentIcon,
      },
      {
        path: routeConstant.collaborator.notifications.path,
        title: routeConstant.collaborator.notifications.title,
        Icon: Icons.Bell,
        IconActive: Icons.Bell,
      },
    ],
  },
  {
    title: "Setting",
    paths: [
      {
        path: routeConstant.collaborator.accountSetting.path,
        title: routeConstant.collaborator.accountSetting.title,
        Icon: Icons.Settings,
        IconActive: Icons.Settings,
      },
    ],
  },
];

export const mobileNavItemsClient: MobileNavItem[] = [
  {
    path: routeConstant.client.projects.path,
    label: "Projects",
    icon: Icons.ProjectIcon2,
  },
  {
    path: routeConstant.client.documents.path,
    label: "Documents",
    icon: Icons.DocumentIcon2,
  },
  {
    path: routeConstant.client.accountSetting.path,
    label: "Settings",
    icon: Icons.SettingsIcon2,
  },
  {
    path: routeConstant.client.contact.path,
    label: "Support",
    icon: Icons.ChatIcon2,
  },
];

export const mobileNavItemsCollaborator: MobileNavItem[] = [
  {
    path: routeConstant.collaborator.projects.path,
    label: "Projects",
    icon: Icons.ProjectIcon2,
  },
  {
    path: routeConstant.collaborator.documents.path,
    label: "Documents",
    icon: Icons.DocumentIcon2,
  },
  {
    path: routeConstant.collaborator.accountSetting.path,
    label: "Settings",
    icon: Icons.SettingsIcon2,
  },
  {
    path: routeConstant.collaborator.contact.path,
    label: "Support",
    icon: Icons.ChatIcon2,
  },
];

export const mobileNavItemsBuilder: MobileNavItem[] = [
  {
    path: routeConstant.builder.projects.path,
    label: "Projects",
    icon: Icons.ProjectsIcon,
  },
  {
    path: routeConstant.builder.notifications.path,
    label: "History",
    icon: Icons.Bell,
  },
  {
    path: routeConstant.builder.accountSetting.path,
    label: "Settings",
    icon: Icons.Settings,
  },
];

export const COLLABORATOR_ROLES = [
  {
    type: "collaborator" as const,
    title: "Collaborator",
    description:
      "Additional authorized contact: View, Comment, Request changes, Approve",
  },
  {
    type: "builder" as const,
    title: "Builder",
    description: "Builder working on this project",
  },
];

export {
  sideBarConstantsDesigner,
  clientSideBarConstants,
  builderSideBarConstants,
  collaboratorSideBarConstants,
};
